<template>
  <div class="seomain">
    <st-loading :loading="fLoading" :title="fTitle"></st-loading>
    <st-header
      title="采购入库"
      :back-able="true"
      :close-able="true"
    >
      <template slot="header-right">
        <span>
          更多
        </span>
      </template>
    </st-header>
    <van-popup v-model:show="showWarehouse" round position="bottom" v-if="showWarehouse">
      <div class="tool-bar" style="overflow: hidden;padding: 2px 10px;">
        <div 
          style="float: left;padding: 10px 15px;color: #969799;"
          @click="cancelBatchWarehouse"
        >取消</div>
        <div
          style="float: right;padding: 10px 15px;color: #576b95;"
          @click="saveWarehouse"
        >确定</div>
      </div>
      <p class="van-field-p" style="padding: 0px 15px;">
        <st-select
          :readonly="true"
          v-model="actWarehouse['warehouse_id']"
          name="warehouse_id"
          placeholder="请选择仓库"
          :options="options['getWarehouse']"
          @changeText="changeWarehouseText"
          @change="changeBatchWarehouse"
        >
        </st-select>
        <span style="color: red;font-size: 12px;" v-if="batchWarehouseErr">{{ batchWarehouseErr }}</span>
      </p>
      <div style="overflow: hidden;">
        <div style="float: right;margin: 15px 40px 0px;" @click.prevent="batchCheckAll">
          <span>全选&nbsp;</span>
          <el-checkbox v-model="batchCheckIsAll" class="batch-warehouse-all-check"></el-checkbox>
        </div>
      </div>
     
      <div class="popup-sku-list" style="min-height: 390px;">
        <div v-if="!batchWarehouseErr">
          <template v-for="(item, ind) in info.items">
            <div :key="ind" class="popup-sku" v-if="item.storageing > 0 && !(itemsFormData[item.id].warehouse_id > 0 && itemsFormData[item.id].warehouse_id !== actWarehouse['warehouse_id'])">
              <div style="float: left;font-size: 14px;line-height: 15px;">
                {{ item['sku'] }} <br>
                <span style="font-size: 12px;">已入库：{{ item.storageed }}</span>
                &emsp;
                <span style="font-size: 12px;color: red">待入库：{{ item.storageing }}</span>
              </div>
              <div style="float: right;margin-right: 15px;transform: translateY(10px);">
                <el-checkbox class="batch-warehouse-checkbox" @change="changeWarehouseSku" :sku-id="item['id']" v-model="actCheckbox[item['id']]"></el-checkbox>
              </div>
            </div>
          </template>
        </div>
        
      </div>
    </van-popup>


    <div class="tab-content">
      <div class="st-list-box pan-1">
        <div class="st-list">
          <div class="st-list-top">
            <div class="t-tit">{{ info.code }}</div>
          </div>
          <div class="st-list-main">
            <p>供应商： {{ info.supplier_name }}</p>
            <div class="upload-filed">
              <div style="float: left;">上传箱单：</div>
              <st-file-upload v-model="info['packing_files_array']"></st-file-upload>
            </div>
            <div class="upload-filed">
              <div style="float: left;">上传采购单：</div>
              <st-file-upload v-model="info['po_files_array']"></st-file-upload>
            </div>

            <p>批量选择仓库：</p>
            <div class="warehouse-list">
              <div 
                class="warehouse-list-item" 
                v-for="(v, i) in warehouseList"
                :key="i"
                @click="openWarehouse(i)"
              >
                <div style="float: left;padding-top: 10px;">
                  <span style="font-size: 16px;font-weight: 500;">{{ v.warehouse_name }}</span> <br>
                  <span style="font-size: 12px;padding-left: 2px;color: rgba(42, 130, 228, 1)">已勾选sku：{{ v.skuList.length  }}</span>
                </div style="float: right;">

                <div style="float: right;font-size: 20px;font-weight: 600;line-height: 40px;">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <p
                class="st-opt-btn"
                @click="addWarehouse();"
                style="background-color: rgb(103,117,136);border-radius: 5px;margin-top: 10px;"
              >
                <span>添加仓库</span>
              </p>
            </div>

            <p
              class="st-opt-btn"
              @click="batchSubClick();"
              style="background-color: rgb(42 130 228);border-radius: 5px;margin-top: 20px;"
            >
              <span style="background-color: rgb(42 130 228);">批量提交</span>
            </p>
            
          </div>
        </div>
      </div>

      <div class="st-list-box pan-1">
        <div class="st-list" v-for="(v, i) in info.items">
          <div class="st-list-top">
            <div class="t-tit">{{ info.code }}</div>
            <div class="t-status">{{ v.quality_text }}</div>
          </div>
          <div class="st-list-main">
            <p>SKU： {{ v.sku }}</p>
            <p>品&emsp;&emsp;类：{{ v.category_name }}</p>
            <p>品&emsp;&emsp;牌：{{ v.brand }}</p>
            <p>型&emsp;&emsp;号：{{ v.model }}</p>
            <p>配&emsp;&emsp;置：{{ v.deploy }}</p>
            <p>已&nbsp;&nbsp;入 库：{{ v.storageed }}</p>
            <p style="color: red;">待&nbsp;&nbsp;入 库：{{ v.storageing }}</p>
            <p>备&emsp;&emsp;注：{{ v.remark }}</p>
            <div class="upload-filed">
              <div style="float: left;">上传箱单：</div>
              <st-file-upload v-model="info['packing_files_array']"></st-file-upload>
            </div>
            <div class="upload-filed">
              <div style="float: left;">上传采购单：</div>
              <st-file-upload v-model="info['po_files_array']"></st-file-upload>
            </div>

            <p class="van-field-p" v-if="v.storageing">
              <st-select
                :readonly="true"
                v-model="itemsFormData[v.id]['warehouse_id']"
                name="warehouse_id"
                placeholder="请选择仓库"
                :options="options['getWarehouse']"
                @change="(val, text) => { warehouseChange(val, text, v.id, itemsFormData[v.id]['warehouse_id']) }"
              >
              </st-select>
            </p>

            <p  class="van-field-p" v-if="v.storageing">
              <van-field
                v-model="itemsFormData[v.id]['storageing']"
                name="入库数量"
                label=""
                placeholder="入库数量"
                class="num-van-field"
                type="number"
              />
              
              <van-button class="st-van-btn-primary" @click="submit(v.id)">
                确定
              </van-button>
            </p>
            
          </div>
        </div>
      </div>
    </div>

    <batch-enter-store
      :visiable.sync="batchEnterStoreShow"
      v-model="itemsFormData"
      :order-info="info"
      :warehouse-list="warehouseList"
      @confirm="submit"
    ></batch-enter-store>
  </div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StHeader from "@/components/layout/Header.vue";
import StLoading from "@/components/layout/FullLoading.vue";
import StSelect from "@/components/Select.vue";
import { getWarehouse } from "@/views/Sto/purchase/conf/options";
import batchEnterStore from "@/views/Sto/purchase/component/batch-enter-store.vue";

export default {
  components: {
    'st-file-upload': StFileUpload,
    "st-header": StHeader,
    'st-select': StSelect,
    'batch-enter-store': batchEnterStore,
    "st-loading": StLoading,
  },
  props: {  },
  data() {
    return {
      fLoading: false, // 全屏加载
      fTitle: "提交中",
      info: {},
      itemsFormData: {},
      infoFormData: {
        packing_files_array: [],
        po_files_array: [],
      },
      formDataText: {},
      options: {
        getWarehouse
      },

      warehouseList: [],
      showWarehouse: false, // 是否打开仓库编辑
      actWarehouse: {},
      actCheckbox: {},
      actWarehouseIndex: '',
      batchWarehouseErr: '', // 批量处理仓库弹窗中 错误提醒

      batchCheckIsAll: false,

      batchEnterStoreShow: false,
      warehouseMap: {},
    };
  },
  watch: {},

  methods: {
    init() {
      this.getInfo();
    },

    // 获取详情 
    getInfo() {
      this.$post(this.$api.stEnterStoreDetail, { id: this.$route.params.id }).then((res) => {
        if (res.code !== 200) {
          this.$toast.fail(res['msg'] ? res['msg'] : '请求详情异常，请稍后重试');
          return;
        }
        this.info = res.data;
        let infoFormData = {
          po_files: this.info['po_files_array'],
          packing_files: this.info['packing_files_array'] // 箱单
        };

        this.$set(this, ['infoFormData'], infoFormData);

        ;

        let empItems = {};
        this.info.items.forEach((item) => {
          empItems = { 
            id: item.id ? item.id.toString() : item.id,
            warehouse_id: '',
            storageing: '',
            products_id: item.products_id,
          };
          // 如果没有设置  给个默认值  如果有 则不调动
          if (!this.itemsFormData[item.id]) {
            console.log('fclep', empItems);
            this.$set(this.itemsFormData, [item.id], empItems);
          }

          // 关闭加载
          this.fLoading = false;
        });

      });
    },

    /* 入库 提交到接口
    * proId 产品id
    */ 
    submit(proId = 0, items) {
      this.fLoading = true;
      let formData = {};
      formData['packing_files'] = this.infoFormData['packing_files'].length > 0 ?  this.infoFormData['packing_files'].map((item) => { return item.url }).join(',') : '';
      formData['po_files'] = this.infoFormData['po_files'].length > 0 ?  this.infoFormData['po_files'].map((item) => { return item.url }).join(',') : '';
      
      formData['items']  = [];
      // 单个
      if (proId) {
        formData['items'].push(this.itemsFormData[proId]);
      } else {
        formData['items'] = items;
      }

      this.$post(`${this.$api.stEnterStore}${this.$route.params.id}`, formData).then((res) => {
        if (res.code !== 200) {
          this.$toast.fail(res.msg ? res.msg : '提交请求异常，请稍后重试！');
          this.fLoading = false;
        } else {
          // 提交成功后 清除掉填写的数据，单个的只清除本身
          if (proId) {
            this.itemsFormData[proId]['storageing'] = '';
          } else {
            // 批量的 全部清掉
            for(let i in this.itemsFormData) {
              this.itemsFormData[i].storageing = '';
            }
          }

          this.getInfo();
          this.$toast.success('提交成功');
        }
      });
    },

    // #region 仓库操作
    // 新增仓库
    addWarehouse() {
      this.actCheckbox = {};
      this.actWarehouseIndex = '';
      this.actWarehouse = {};
      this.showWarehouse = true;
    },

    // 编辑仓库
    openWarehouse(index) {
      this.actCheckbox = {};
      this.actWarehouseIndex = index;
      this.actWarehouse = this.warehouseList[index];

      let actCheckbox = [];
      this.actWarehouse.skuList.forEach((v, i) => {
        actCheckbox[v.id] = true;
      });

      this.$set(this, ['actCheckbox'], actCheckbox);
      this.checkBatchWarehouseIsAll();
      this.showWarehouse = true;
    },

    // 确定编辑仓库
    saveWarehouse() {
      // 如果没有选择仓库
      if (!this.actWarehouse['warehouse_id']) {
        this.$toast.fail('请选择仓库');
        return;
      }

      // 如果选择的仓库重复了
      let existWarehouseIndex = this.warehouseList.findIndex((val) => { return val.warehouse_id === this.actWarehouse['warehouse_id'] });
      if (existWarehouseIndex >= 0 && existWarehouseIndex !== this.actWarehouseIndex) {
        this.$toast.fail('该仓库已存在，请勿重复选择');
        return;
      }

      // 追加
      if (this.actWarehouseIndex === '') {
        this.warehouseList.push(this.actWarehouse);
      } else {
        // 覆盖
        this.warehouseList[this.actWarehouseIndex] = this.actWarehouse;
      }

      // 同步
      // 找到应用该仓库的，然后去掉
      for(let itemInd in this.itemsFormData) {
        let itemFormData = this.itemsFormData[itemInd];
        if (itemFormData.warehouse_id === this.actWarehouse.warehouse_id) {
          this.itemsFormData[itemInd].warehouse_id = '';
        }
      }

      this.actWarehouse.skuList.forEach((item) => {
        // 找到对应的sku 赋值仓库
        this.itemsFormData[item.id].warehouse_id = this.actWarehouse.warehouse_id;
      })

      this.showWarehouse = false;
    },

    // 取消编辑仓库
    cancelBatchWarehouse() {
      this.actWarehouseIndex = '';
      this.actWarehouse = {};
      this.showWarehouse = false;
      this.batchWarehouseErr = '';
    },
    // #endregion 仓库操作


    // #region checkbox
    // sku checkbox 更改
    changeWarehouseSku(val, event) {
      let skuId = event.target.parentNode.parentNode.getAttribute('sku-id');
      
      // 初始化
      if (!this.actWarehouse.skuList) { this.actWarehouse.skuList = []; }

      let existIndex = this.actWarehouse.skuList.findIndex((item) => { return item.id === skuId });

      // 如果勾中
      if (val) {
        if (existIndex < 0) {
          this.actWarehouse.skuList.push({ 'id': skuId });
        }
      } else {
        // 如果没有勾中
        if (existIndex >= 0) {
          this.actWarehouse.skuList.splice(existIndex, 1);
        }
      }

      this.checkBatchWarehouseIsAll();
    },

    // 批量处理仓库判断是不是全选 checkbox
    checkBatchWarehouseIsAll() {
      let boxList = document.getElementsByClassName('batch-warehouse-checkbox');
      if (boxList.length <= 0) return;
      let isCheckAll = true;
      for (let i in boxList) {
        let ele = boxList[i];
        if (typeof ele == 'number') {
          break;
        }
        let skuId = ele.getAttribute('sku-id');
        // 只要有一个是没有勾中的  就是没有勾中
        if (!this.actCheckbox[skuId]) {
          isCheckAll = false;
          break;
        }
      }

      this.batchCheckIsAll = isCheckAll;
    },

    // 全选 checkbox
    batchCheckAll(e) {
      let allCheckBox = document.getElementsByClassName('batch-warehouse-all-check');
      if (allCheckBox.length <= 0) return;
      allCheckBox = allCheckBox[0];

      // 当是1的时候会反反得正
      this.batchCheckIsAll = !this.batchCheckIsAll;

      let boxList = document.getElementsByClassName('batch-warehouse-checkbox');
      if (boxList.length <= 0) return;

      this.actWarehouse.skuList = [];
      for (let i in boxList) {
        let ele = boxList[i];
        if (typeof ele == 'number') {
          break;
        }
        let skuId = ele.getAttribute('sku-id');
        this.actCheckbox[skuId] = this.batchCheckIsAll;
        if (this.batchCheckIsAll)  this.actWarehouse.skuList.push({ id: skuId });
      }
    },

    // #endregion checkbox

    // #region 批量仓库 事件
    // 仓库名称改变
    changeWarehouseText(val) {
      this.actWarehouse['warehouse_name'] = val;
    },

    // 批量仓库
    changeBatchWarehouse(val, text) {
      // actWarehouseIndex === '' 代表新增，新增要避免重复
      let existInd = this.warehouseList.findIndex((item) => { return item.warehouse_id === val });
      if (existInd >= 0 && (this.actWarehouseIndex === '' || existInd !== this.actWarehouseIndex)) {
        this.batchWarehouseErr = '该仓库已经存在，请勿重复选择';
        return;
      }
      this.batchWarehouseErr = '';
    },

    // 仓库选择 更改
    warehouseChange(val, text, index, oldWarehouseId) {
      let skuId = this.itemsFormData[index].id;

      // 如果 老的仓库 和 新的仓库 没变  不动
      if (val === oldWarehouseId) {
        return;
      }

      let warehouseListOldInd = -1;
      let warehouseListNewInd = -1;

      // 从批量仓库选择中找到老的 仓库， 和新的仓库
      for (let i in this.warehouseList) {
        if (this.warehouseList[i].warehouse_id === oldWarehouseId) warehouseListOldInd = i;
        if (this.warehouseList[i].warehouse_id === val) warehouseListNewInd = i;
      }

      // 从老的 删除
      if (warehouseListOldInd >= 0) {
        let existOldInd = this.warehouseList[warehouseListOldInd].skuList.findIndex((item) => { return item.id = skuId; });
        if (existOldInd >= 0) {
          this.warehouseList[warehouseListOldInd].skuList.splice(existOldInd, 1);
        }
      }

      // 添加到新的里面去
      //  存在推进去
      if (warehouseListNewInd >= 0) {
        if (!this.warehouseList[warehouseListNewInd].skuList) {
          this.warehouseList[warehouseListNewInd].skuList = [];
        }
        this.warehouseList[warehouseListNewInd].skuList.push({id: skuId});
      } else {
        // 不存在 将仓库推进去
        this.warehouseList.push(
          {
            warehouse_id: val,
            warehouse_name: text,
            skuList: [{id: skuId}],
          }
        );
      }

    },
    // #endregion 批量仓库 事件

    // #region 批量提交 操作
    // 批量提交 
    batchSubClick() {
      // 没有sku 的 时候单纯的提交一下文件
      let warehouseList = this.warehouseList.filter(item => { console.log('fclitem.skuList', item.skuList); return item.skuList.length > 0; })
      console.log('warehouseList', warehouseList);
      if (warehouseList.length <= 0) {
        this.submit();
        return;
      }

      this.batchEnterStoreShow = true;
    },

    
    // #endregion 批量提交 操作


    // #region 提交后 刷新数据

    /**
     * 提交后  重新接口上获取数据进行更新  除了本身填的数据需要清0 其他的都不变
     * 
     */

     // 重新更替页面数据
     reMountData() {
      this.getInfo();
     },

  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.upload-filed {
  overflow: hidden;
  /deep/ .avatar-uploader {
    float: left;
  }  
}
.van-field-p {
  margin-top: 10px;
  overflow: hidden;
  .van-field {
    box-shadow: inset 0 0 0 2px rgb(223,223,223);
    border-radius: 5px;
  }
  .num-van-field {
    width: 80%;
    float: left;
  }

  .st-van-btn-primary {
    float: right;
  }
}

.st-list {
  padding-top: 30px;
}

.warehouse-list {
  .warehouse-list-item {
    line-height: 16px;
    margin: 0px 10px;
    padding: 5px 5px;
    overflow: hidden;
    border-bottom:  1px solid rgb(189, 186, 186);
  }
}

.popup-sku-list {
  min-height: 390px;
  margin-top: 20px;
  overflow: scroll;

  .popup-sku {
    padding: 10px 15px;
    overflow: hidden;
    margin: 0px 15px;
    border-bottom:  1px solid rgb(189, 186, 186);
  }


}

</style>
